import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { downloadEmployeePdf } from "../../api/documents";
import { TILE_3D, tileBtn } from "./actionTile";

export const EmployeePdfButton = ({ userId }) => {
  const { t, i18n } = useTranslation();
  const [busy, setBusy] = useState(false);

  const download = async () => {
    setBusy(true);
    try {
      await downloadEmployeePdf(userId, i18n.language);
    } catch {
      toast.error(t("errors.generic"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <button className={tileBtn("bg-rose-500")} style={TILE_3D} data-testid="detail-pdf" disabled={busy} onClick={download}>
      {t("docs.exportPdf")}
    </button>
  );
};
